import translate, { translateWithElements, getPath, isTranslationExists, translateResultObject } from './translate';
export { translateWithElements, getPath, isTranslationExists, translateResultObject };
export default translate;